import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"

const rootElement = document.getElementById("root")

if (!rootElement) {
	throw new Error("Root element not found")
}

const root = ReactDOM.createRoot(rootElement)

// Обработка ошибок монтирования
const renderApp = () => {
	try {
		// В production НЕ используем StrictMode (убирает двойной рендер)
		// В development - можно оставить для проверки, но будет 2 запроса вместо 1
		if (process.env.NODE_ENV === "production") {
			root.render(<App />)
		} else {
			// В development - StrictMode для проверки, но понимаем что будет двойной рендер
			root.render(
				<React.StrictMode>
					<App />
				</React.StrictMode>
			)
		}
	} catch (error) {
		console.error("Failed to render app:", error)
		// Показываем ошибку пользователю
		rootElement.innerHTML = `
			<div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; flex-direction: column; padding: 20px; font-family: system-ui, -apple-system, sans-serif;">
				<h1 style="color: #d32f2f; margin-bottom: 16px;">Ошибка загрузки приложения</h1>
				<p style="color: #666; margin-bottom: 24px; text-align: center;">Произошла ошибка при загрузке приложения. Пожалуйста, обновите страницу.</p>
				<button onclick="window.location.reload()" style="padding: 12px 24px; background: #1976d2; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 16px;">
					Обновить страницу
				</button>
				${process.env.NODE_ENV === "development" ? `<pre style="margin-top: 24px; padding: 16px; background: #f5f5f5; border-radius: 8px; overflow: auto; max-width: 800px; font-size: 12px;">${error instanceof Error ? error.stack : String(error)}</pre>` : ""}
			</div>
		`
	}
}

renderApp()
